import { Component, Input, Output, EventEmitter } from "@angular/core";
import {
  VAIconRegistryService,
  chevronRight,
  slidersHorizontal,
  chevronDown,
} from "@va/core-library/icons";
import {
  getTreeFilterdData,
  getListFilterdData,
  cloneThreeLevelTree,
} from "src/app/comparative-analysis/comparative-analysis-utils";
import { Subscription } from "rxjs";
import { ComparativeAnalysisService } from "src/app/comparative-analysis/comparative-analysis.service";
import { Router } from "@angular/router";
import { UntypedFormControl } from "@angular/forms";

@Component({
  selector: "app-comparative-search-menu-content",
  templateUrl: "./comparative-search-menu-content.component.html",
  styleUrls: ["./comparative-search-menu-content.component.scss"],
})
export class ComparativeSearchMenuContentComponent {
  currenttabType;
  delayMenuTimer: number | null = null;
  delaySelectTimer: number | null = null;
  @Input() searchedTerm: string;
  @Input() menuList = [
    {
      id: "industry",
      label: "Industry Peers",
      dataProperty: "industryMenuData",
    },
    {
      id: "comp_table",
      label: "Comp Tables",
      isLeaf: false,
      dataProperty: "compTableMenuData",
    },
    {
      id: "custom_analysis",
      label: "Custom Analysis",
      isLeaf: false,
      dataProperty: "customAnalysisMenuData",
    },
    {
      id: "watchlist",
      label: "Watchlists",
      isLeaf: false,
      dataProperty: "watchlistMenuData",
    },
  ];
  @Input() industryData = [];
  @Input() compTableData = [];
  @Input() customAnalysisData = [];
  @Input() watchlistData = [];
  @Input() marketCapData = [];
  @Input() selectedMarketCapsId;
  @Input() selectedCountriesId;
  @Input() selectedRegionsId;
  @Input() geographyData = [];
  @Input() selectionInMegaMenu = {};
  @Input() isIndustryMenuApiInProgress = false;
  @Input() isCustomMenuApiInProgress = false;
  @Input() isCompMenuApiInProgress = false;
  @Input() isWatchlistMenuApiInProgress = false;
  @Input() isMarketGeoApiInProgress = false;
  @Input() otherGeoLen;
  @Input() activatedOptions;
  @Input() selectedIndustryData;
  @Input() selectedSystemData;
  @Input() selectedWatchlistId;
  @Input() selectedCustomAnalysisId;

  @Output() onIndustryApply: EventEmitter<any> = new EventEmitter();
  @Output() onWatchlistApply: EventEmitter<any> = new EventEmitter();
  @Output() onCustomAnalysisApply: EventEmitter<any> = new EventEmitter();
  @Output() onCompTabelApply: EventEmitter<any> = new EventEmitter();
  @Output() onCancelClick: EventEmitter<any> = new EventEmitter();

  industryMenuData = [];
  compTableMenuData = [];
  customAnalysisMenuData = [];
  watchlistMenuData = [];
  menuSearchCount = {
    industry: 0,
    comp_table: 0,
    custom_analysis: 0,
    watchlist: 0,
  };
  showNoResultsFound = false;

  // subscribers
  comparativEanalysisMenuSubscriber: Subscription;
  marketGeoSubscriber: Subscription;
  routeParamSubscriber: Subscription;

  queryField: UntypedFormControl = new UntypedFormControl();

  constructor(
    private iconRegistry: VAIconRegistryService,
    private comparativeAnalysisService: ComparativeAnalysisService,
    public router: Router,
  ) {
    this.iconRegistry.registerIcons([
      chevronRight,
      slidersHorizontal,
      chevronDown,
    ]);
  }

  ngOnInit() {}

  ngOnChanges(changes) {
    if (
      changes.industryData &&
      changes.industryData.currentValue !== changes.industryData.previousValue
    ) {
      this.industryMenuData = this.industryData
        ? cloneThreeLevelTree(this.industryData)
        : [];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        industry: this.industryMenuData.length,
      };
    }
    if (
      changes.compTableData &&
      changes.compTableData.currentValue !== changes.compTableData.previousValue
    ) {
      this.compTableMenuData = this.compTableData
        ? cloneThreeLevelTree(this.compTableData)
        : [];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        comp_table: this.compTableMenuData.length,
      };
    }
    if (
      changes.customAnalysisData &&
      changes.customAnalysisData.currentValue !==
        changes.customAnalysisData.previousValue
    ) {
      this.customAnalysisMenuData = this.customAnalysisData
        ? [...this.customAnalysisData]
        : [];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        custom_analysis: this.customAnalysisMenuData.length,
      };
    }
    if (
      changes.watchlistData &&
      changes.watchlistData.currentValue !== changes.watchlistData.previousValue
    ) {
      this.watchlistMenuData = this.watchlistData
        ? cloneThreeLevelTree(this.watchlistData)
        : [];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        watchlist: this.watchlistMenuData.length,
      };
    }
    if (
      changes.searchedTerm &&
      changes.searchedTerm.currentValue !== changes.searchedTerm.previousValue
    ) {
      this.handleInputChange(this.searchedTerm);
    }
  }

  clearDelaySelectTimer(): void {
    if (this.delaySelectTimer) {
      clearTimeout(this.delaySelectTimer);
      this.delaySelectTimer = null;
    }
  }

  clearDelayMenuTimer(): void {
    if (this.delayMenuTimer) {
      clearTimeout(this.delayMenuTimer);
      this.delayMenuTimer = null;
    }
  }

  handleInputChange(text) {
    this.showNoResultsFound = false;
    this.industryMenuData = getTreeFilterdData(text, this.industryData);
    this.compTableMenuData = getTreeFilterdData(text, this.compTableData);
    this.customAnalysisMenuData = getListFilterdData(
      text,
      this.customAnalysisData,
    );
    this.watchlistMenuData = getListFilterdData(text, this.watchlistData);
    this.menuSearchCount = {
      industry: this.industryMenuData.length,
      comp_table: this.compTableMenuData.length,
      custom_analysis: this.customAnalysisMenuData.length,
      watchlist: this.watchlistMenuData.length,
    };
    // check this
    // this.activatedOptions = this.menuSearchCount.industry
    //   ? "industry"
    //   : this.menuSearchCount.comp_table
    //     ? "comp_table"
    //     : this.menuSearchCount.custom_analysis
    //       ? "custom_analysis"
    //       : this.menuSearchCount.watchlist
    //         ? "watchlist"
    //         : undefined;
    // console.log("Hey in handleinput chnges", this.activatedOptions)
    if (!this.activatedOptions && text) {
      this.showNoResultsFound = true;
    }
  }

  handleMenuItemClick(item, event) {
    if (event) {
      event.preventDefault();
    }
    if (item && item.disabled) {
      return;
    }
  }

  setOptionActivated(item, id): void {
    if (item.disabled) {
      return;
    }
    this.activatedOptions = id;
  }

  delaySetOptionActivated(item, id): void {
    this.clearDelaySelectTimer();
    this.delaySelectTimer = window.setTimeout(() => {
      this.setOptionActivated(item, id);
      this.delaySelectTimer = null;
    }, 100);
  }

  handleMenuItemMouseEnter(item, event) {
    event.preventDefault();
    this.delaySetOptionActivated(item, item.id);
  }

  handleMenuItemMouseLeave(item, event) {
    event.preventDefault();
    if (!item.isLeaf) {
      this.clearDelaySelectTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearDelayMenuTimer();
    this.clearDelaySelectTimer();
  }

  handleIndustryMenuCancelButtonClick() {
    this.onCancelClick.emit();
  }

  handleWatchlistMenuCancelButtonClick() {
    this.onCancelClick.emit();
  }

  handleIndustryMenuApplyButtonClick(data) {
    this.onIndustryApply.emit(data);
  }

  handleWatchlistMenuApplyButtonClick(data) {
    this.onWatchlistApply.emit(data);
  }

  handlSystemItemClick(id) {
    this.onCompTabelApply.emit(id);
  }

  handleCustomItemClick(data) {
    this.onCustomAnalysisApply.emit(data);
  }
}
